<template>
  <v-container>
    <v-row>
      <v-col>
        <v-list class="elevation-1 mb-5">
          <MenuListHeader :translationKey="`kodeverkTable.type.${types[0].toLowerCase()}`" />
          <template v-if="menuItems.length === 0">
            <v-skeleton-loader
              v-for="index in 20"
              :key="index"
              type="list-item"
              :loading="true"
              class="mx-auto"
            />
          </template>
          <MenuListItem
            v-else
            v-for="(item, i) in menuItems.filter(i => i.type === types[0])"
            :key="types[0] + i"
            :item="item"
          />
        </v-list>
      </v-col>
      <v-col>
        <v-list
          v-for="(title, i) in types.filter(t => t != types[0])"
          :key="i"
          class="elevation-1 mb-5"
        >
          <MenuListHeader
            :translationKey="`kodeverkTable.type.${title.toLowerCase()}`"
            :showPublishDate="title === types[1]"
          />
          <template v-if="menuItems.length == 0">
            <v-skeleton-loader
              v-for="index in 5"
              :key="index"
              type="list-item"
              :loading="true"
              class="mx-auto"
            />
          </template>
          <MenuListItem
            v-else
            v-for="(item, i) in menuItems.filter(i => i.type === title)"
            :key="title + i"
            :item="item"
          />
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import MenuListItem from '@/components/tableList/MenuListItem.vue'
import MenuListHeader from '@/components/tableList/MenuListHeader.vue'
import { storeToRefs } from 'pinia'
import { useMenuItemsStore } from '@/store/modules/menuItems'

const { menuItems } = storeToRefs(useMenuItemsStore())

const types: string[] = ['TABLE', 'TABLE_NO_XML', 'LOGS', 'OTHER']
</script>
